/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module DiagramModules
 */

import {
    Component,
    Input,
    OnInit,
} from '@angular/core';
import { ILabelData } from '../label-color-optional';
import './label-count-row.component.less';

/**
 * Data format needed to create this component.
 */
export interface ILabelRowData extends ILabelData {
    count: number | string;
}

/**
 * @description
 *      Reusable component for showing 1 combination of label and count, and optional color.
 * @author Akul Aggarwal
 */
@Component({
    selector: 'label-count-row',
    templateUrl: './label-count-row.component.html',
})
export class LabelCountRowComponent implements OnInit {
    @Input()
    public readonly labelRowData: ILabelRowData;

    public labelData: ILabelData;

    /** @override */
    public ngOnInit(): void {
        this.createLabelData();
    }

    /**
     * Create object needed by child component.
     */
    private createLabelData = (): void => {
        const {
            color,
            label,
        } = this.labelRowData;

        this.labelData = {
            color,
            label,
        };
    };
}
